/** typeguard for array of strings */
const isStringArray = (arr: any[]): arr is string[] => arr.every(item => typeof item === 'string')

export { isStringArray }
